import { cva, type VariantProps } from 'class-variance-authority'
import { z } from 'zod'

export const getPromptFormSchema = (isPrivateVisibilityEnabled: boolean) =>
  z.object({
    query: z.string().min(1, 'Please enter a message').trim(),
    visibility: isPrivateVisibilityEnabled
      ? z.enum(['public', 'private'])
      : z.enum(['public']),
    files: z.array(z.instanceof(File)).default([]).optional(),
  })

export type PromptFormData = z.infer<ReturnType<typeof getPromptFormSchema>>

export const promptFormVariants = cva(
  'relative w-full rounded-[20px] p-4 focus-within:outline-dashed focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-blue-600 max-md:max-w-full',
  {
    variants: {
      variant: {
        homepage: 'bg-white shadow-prompt',
        dashboard: 'bg-grey-02 border ',
        playbook: 'bg-white border ',
      },
    },
    defaultVariants: {
      variant: 'homepage',
    },
  }
)

export type PromptFormVariant = VariantProps<
  typeof promptFormVariants
>['variant']

export interface PromptFormProps
  extends VariantProps<typeof promptFormVariants> {
  onSubmit: (data: PromptFormData) => Promise<void>
  className?: string
  maxFiles?: number
  maxFileSize?: number // in MB
  acceptedFileTypes?: string[]
  showExamples?: boolean
  hideVisibilityControl?: boolean
  disabled?: boolean
  placeholder?: string
  value?: Partial<PromptFormData>
}

export interface FilePreviewProps {
  file: File
  onRemove: () => void
  variant?: 'homepage' | 'dashboard'
}
